/*
 * @Description:组织权限--组织用户/角色权限
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  部门: 'Department',
  同步: 'Sync',
  人员: 'Personnel',
  个人: 'Individual',
  角色: 'Role',
  新建: 'Add',
  系统: 'System',
  移除: 'Remove',
  离职: 'Resignation',
  暂停: 'Suspend',
  正常: 'Normal',
  姓名: 'Name',
  未激活: 'Not activated',
  未加入: 'Not joined',
  主规则: 'Main rule',
  负责人: 'Person in charge',
  手机号: 'Phone number',
  部门名称: 'Department name',
  部门主管: 'Department manager',
  补充规则: 'Additional rules',
  角色员工: 'Role employee',
  数据权限: 'Data permissions',
  操作权限: 'Operation permissions',
  添加人员: 'Add personnel',
  新建角色: 'Create role',
  编辑角色: 'Edit role',
  选择人员: 'Select personnel',
  已离职用户: 'Resigned user',
  仅自己数据: 'Only own data',
  整个公司数据: 'Entire company data',
  同步数据成功: 'Data sync successful',
  确认移除该员工: 'Confirm to remove this employee?',
  确认删除该角色: 'Confirm to delete this role?',
  指定部门或人员: 'Specify department or personnel',
  部门名称不能为空: 'Department name cannot be empty',
  所在部门及以下数据: 'Data under the current department',
  修改前后角色名一致: 'Role name is the same before and after modification',
  '同步数据失败，请重试': 'Data sync failed, please try again',
  删除后该角色下员工将无使用权限: 'After deletion, employees under this role will have no usage rights',
  移除后该员工将无法使用角色相应的权限: 'After removal, the employee will not be able to use the corresponding permissions of the role',
  离职用户数据管理: 'Resignation User Data Processing',
  停用成员数据管理: 'Disable User Data Management',
  全部转移: 'Transfer all',
  离职前所在部门: 'Department before Resignation',
  停用前所在部门: 'Department before Disable',
  停用前所属公司: 'Company before Disable',
  停用日期: 'Disable Date',
  选择离职用户: 'Select Resigned User',
  选择停用用户: 'Select Disabled User',
  搜索离职人员姓名: 'Search for Resigned Employee Name',
  搜索停用人员姓名: 'Search for Disabled Employee Name',
  现跟进线索数: 'Current Number of Leads Followed up',
  现负责客户数: 'Current Number of Customers in Charge',
  现负责商机数: 'Current Number of Business Opportunities in Charge',
  现负责报价单数: 'Current Number of Quotations in Charge',
  现负责销售合同数: 'Current Number of Sales Contracts in Charge',
  现负责销售订单数: 'Current Number of Sales Orders in Charge',
  现负责售后服务数: 'Current Number of After-sales Services in Charge',
  变更其他负责人: 'Change Other Person in Charge',
  '请输入部门/公司名称': 'Please enter the name of the department/company',
  已开启坐席成员: 'Agents enabled',
  未开启坐席成员: 'Agents not enabled',
  所属公司: 'Affiliated Company',
  坐席状态: 'Agent Status',
  成员直属上级: 'Immediate Superior',
  性别: 'Gender',
  成员类型: 'Member Type',
  数据来源: 'Data Source',
  是否合并成员: 'Merge Members?',
  最早开启坐席时间: 'Earliest Agent Activation Time',
  最近一次登录时间: 'Latest Login Time',
  未启用: 'Inactive',
  已启用: 'Active',
  取消合并: 'Cancel Merge',
  男: 'Male',
  女: 'Female',
  保密: 'Confidential',
  变更部门: 'Change Department',
  取消关联: 'Unlink',
  新建部门: 'Create Department',
  创建者: 'Creator',
  自建: 'Self-built',
  飞书: 'Feishu',
  失败: 'Failed',
  成功: 'Successful',
  未知: 'Unknown',
  添加子部门: 'Add Sub-department',
  请选择所属部门: 'Please select the affiliated department',
  请选择负责人: 'Please select the person in charge',
  父级部门: 'Parent Department',
  'tips.memberDisabledTip': 'The fields synchronized in Feishu cannot be edited in Firing Code!'
};
